import { Pipe, PipeTransform } from '@angular/core';
import { DriverLedgerCategoryOption } from '../../_models/driver-ledger.model';

@Pipe({ name: 'categoryFilter', standalone: true, pure: true })
export class CategoryFilterPipe implements PipeTransform {
	transform(
		categories: DriverLedgerCategoryOption[] | null,
		query: DriverLedgerCategoryOption | string | null,
	): DriverLedgerCategoryOption[] {
		if (!categories?.length) {
			return [];
		}

		const term = typeof query === 'string' ? query.trim().toLowerCase() : '';
		if (!term) {
			return categories;
		}

		return categories.filter((c) => c.name.toLowerCase().includes(term));
	}
}
